import styled from 'styled-components';

export const MobileAssetInfoOverviewStyled = styled.div`
    padding-bottom: 64px;
`;

export const MobileAssetInfoOverviewAmountStyled = styled.div`
    font-weight: 600;
    font-size: 28px;
    margin-bottom: 16px;
    
    .diff {
        margin-left: 16px;
        font-size: 20px;
        
        svg {
          vertical-align: text-top;
        }
        
        > * {
            margin-left: 8px;
        }
    }
`;

export const MobileAssetInfoOverviewChartStyled = styled.div`
    margin-left: -16px; // @opposite MobileSliderPagesContentStyled
    margin-right: -16px; // @opposite MobileSliderPagesContentStyled
    margin-bottom: 32px;
`;

export const MobileAssetInfoSellBuyMenuStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
    width: 100%;
    padding: 16px 32px;

    > * {
        flex: 1;
        border-radius: 16px;
        padding: 12px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 600;

        &.sell {
            background-color: var(--color-negative);
        }

        &.buy {
            background-color: #4186E1;
        }
    }
`;

export const MobileAssetInfoSellBuyUnavailableStyled = styled.div`
    flex: 1;
    text-align: center;
    padding: 16px;
    font-size: 16px;
    font-weight: 600;
`;
